<!-- RELEASE Mismatch Modal -->
<div class="modal fade" id="isVersionMismatch" tabindex="-1" role="dialog" aria-labelledby="versionMismatchModalTitle"
  aria-hidden="true" style="z-index: 99999!Important;">
  <div class="modal-dialog modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header alert-warning">
        <h5 class="modal-title"><i class="fa fa-warning"></i> Refresh Required</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="clearCache();">&times;</span>
        </button>
      </div>
      <div class="modal-body font-size-14">
        A new version of the application is available. Please click Reload to confirm page reload.
      </div>
      <div class="modal-footer">
        <button type="button" (click)="clearCache();" class="btn btn-primary" title="Reload page">Reload</button>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
